export default "__VITE_ASSET__ByBdG1Lk__"